import service from "@irati/utils/tracking/index";
var tracking = {};
tracking.viewTenantWallet = function () {
    service.trackWalletEvent("wallet_tenant_view");
};
tracking.startTenantWalletTopUp = function () {
    service.trackWalletEvent("wallet_tenant_start_top_up");
};
tracking.completeTenantWalletTopUp = function () {
    service.trackWalletEvent("wallet_tenant_complete_top_up");
};
tracking.startTenantWalletTransferCredit = function () {
    service.trackWalletEvent("wallet_tenant_start_transfer_credit");
};
tracking.completeTenantWalletTransferCredit = function () {
    service.trackWalletEvent("wallet_tenant_complete_transfer_credit");
};
tracking.clickTenantWallet = function () {
    service.trackWalletEvent("wallet_view_tenant_wallet");
};
tracking.clickTenantShowMore = function () {
    service.trackWalletEvent("wallet_t_show_more");
};
tracking.downloadReport = function () {
    service.trackWalletEvent("wallet_t_download_report");
};
tracking.clickTopUp = function () {
    service.trackWalletEvent("wallet_top_up");
};
tracking.enterTopUpValue = function () {
    service.trackWalletEvent("wallet_top_up_value");
};
tracking.selectBankTransfer = function () {
    service.trackWalletEvent("wallet_top_up_bank_transfer");
};
tracking.clickRequestInvoice = function () {
    service.trackWalletEvent("wallet_top_up_bank_transfer_request_invoice");
};
tracking.selectPayWithCard = function () {
    service.trackWalletEvent("wallet_top_up_pay_with_card");
};
tracking.agreeTermsAndConditions = function () {
    service.trackWalletEvent("wallet_top_up_agree_to_t_&_c");
};
tracking.clickTopUpCredit = function () {
    service.trackWalletEvent("wallet_top_up_top_up_credit");
};
tracking.clickTransferCredit = function () {
    service.trackWalletEvent("wallet_transfer");
};
tracking.updateTransferValue = function () {
    service.trackWalletEvent("wallet_transfer_new_value");
};
tracking.updateManager = function () {
    service.trackWalletEvent("wallet_transfer_manager_drop_down");
};
tracking.selectManager = function () {
    service.trackWalletEvent("wallet_transfer_select_manager");
};
tracking.clickTransferCreditCTA = function () {
    service.trackWalletEvent("wallet_transfer_transfer_credit");
};
tracking.clickRefund = function () {
    service.trackWalletEvent("wallet_refund");
};
tracking.enterRefundValue = function () {
    service.trackWalletEvent("wallet_refund_new_value");
};
tracking.updateRefundManager = function () {
    service.trackWalletEvent("wallet_refund_manager_drop_down");
};
tracking.selectRefundManager = function () {
    service.trackWalletEvent("wallet_refund_select_manager");
};
tracking.clickRefundCTA = function () {
    service.trackWalletEvent("wallet_refund_transfer_credit");
};
export default tracking;
